/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";

import { useFormikContext } from "formik";

import {
  SurveySelectInput,
  SurveyTextInput,
  SurveyTextareaInput,
} from "./SurveyInputs";
import { Box } from "@material-ui/core";
import SurveySection from "./SurveySection";
import {
  isTextFieldOption,
  isTextareaOption,
} from "../../../../../utils/surveyOptionTypeUtils";

type TProps = {
  question: {
    options: {
      id: number;
      text: string;
      type: string;
    }[];
    id: number;
    text: string;
    mandatory: boolean;
  };
  questionNumber: number;
  error: string;
};

function SurveyQuestionInput({ question, questionNumber, error }: TProps) {
  const { submitCount } = useFormikContext();

  let input;
  if (question.options.length < 1) {
    return <Box mt={3}>{I18n.t("js-error-not-logged")}</Box>;
  }

  const firstOption = question.options[0];

  if (isTextFieldOption(firstOption)) {
    input = (
      <SurveyTextInput
        question={question}
        errorMsg={error}
        submitCount={submitCount}
      />
    );
  } else if (isTextareaOption(firstOption)) {
    input = (
      <SurveyTextareaInput
        question={question}
        errorMsg={error}
        submitCount={submitCount}
      />
    );
  } else {
    input = (
      <SurveySelectInput
        question={question}
        errorMsg={error}
        submitCount={submitCount}
      />
    );
  }

  return (
    <SurveySection
      title={question.text}
      number={questionNumber}
      mandatory={question.mandatory}
      error={error}
    >
      {input}
    </SurveySection>
  );
}

export default SurveyQuestionInput;
